import script from "./Datatable.vue?vue&type=script&setup=true&lang=js"
export * from "./Datatable.vue?vue&type=script&setup=true&lang=js"

import "./Datatable.vue?vue&type=style&index=0&id=08634840&lang=scss"

const __exports__ = script;

export default __exports__